import React, { useState, useEffect, useRef, useCallback } from "react";
import { createPortal } from "react-dom";
import { Box, Typography, IconButton, Paper } from "@mui/material";
import { leaveSuccess } from "services/constants/SuccessMessages";
import sessionHandling from "services/utils/notificationUtils";
import { CustomAutoCompleteWithLogo } from "components/CustomComponents/CustomAutoCompleteWithLogo";
import * as Mui from "@mui/material";
import {
  Close,
  CloseFullscreen,
  Edit,
  CalendarMonthOutlined,
  DateRangeOutlined,
} from "@mui/icons-material";
import { CustomTextBox } from "components/CustomComponents";
import { parse } from "date-fns";
import { useForm } from "react-hook-form";
import { parentBoxStyle } from "services/constants";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import {
  checkFirstLevelApproverPermission,
  checkSecondLevelApproverPermission,
} from "services/utils/HelperFunction";
import { CustomAutoComplete } from "components/CustomComponents";
import { CustomizedDatePicker } from "components/CustomComponents/CustomizedDatePicker";
import dayjs from "dayjs";
import { useFetch } from "services/hooks/useFetch";
import {
  APP_BAR_OFFSET,
  designColors,
  designRadii,
  designShell,
  designType,
  FORM_ACTION_BUTTON_WIDTH,
  PANEL_DRAWER_WIDTH,
  panelDrawerSx,
} from "services/constants/designTokens";
import {
  PrimaryButton,
  SecondaryButton,
} from "components/CustomComponents/DesignSystemButtons";
import {
  GlobalFieldLabel,
  useExpandedContentLeft,
} from "components/DesignSystem/sharedUiPatterns";
import { SelectedEmployeeHeader } from "../SelectedEmployeeHeader";
import { LeaveDateCalendar } from "./LeaveDateCalendar";
import { OpenFullViewIcon } from "components/DesignSystem/OpenFullViewIcon";
import { tooltipStyleProps } from "services/constants/Styles";
import { PanelHeaderIconButton } from "components/DesignSystem/GlobalSidePanel";

const leaveInfoStyle = {
  variant: "body2",
  sx: {
    mb: 0.5,
    color: designColors.slate600,
    fontSize: 12.5,
    fontWeight: 400,
    lineHeight: 1.45,
  },
};

const leaveFieldLabelSx = {
  fontWeight: 500,
  fontSize: 14,
  color: designColors.slate900,
};

const leaveSectionTitleSx = {
  fontWeight: 600,
  fontSize: 15,
  color: designColors.slate900,
};

const leaveRadioLabelSx = {
  "& .MuiFormControlLabel-label": {
    fontSize: 14,
    color: designColors.slate800,
  },
};

export const Apply = ({
  onClose,
  setReCallApi,
  filteredValue,
  setFilteredValue,
  open = true,
  expanded = false,
  onToggleExpand,
}) => {
  const {
    setValue,
    handleSubmit,
    register,
    watch,
    control,
    reset,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      user_name: "",
      attendance_type: "",
      start_date: null,
      startTime: null,
      endTime: null,
      reason_for_leave: "",
      business_days: "",
      sandwich_applied: false,
    },
  });
  const [showAutoCompleteAvathar, setShowAutoCompleteAvathar] = useState(false);
  const [checkboxChecked, setcheckboxChecked] = useState(true);
  const [multiDaysCheckboxChecked, setMultiDaysCheckboxChecked] =
    useState(false);
  const [firstHalfChecked, setFirstHalfChecked] = useState(false);
  const [secondHalfChecked, setSecondHalfChecked] = useState(false);
  const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
  const [editLeaveYear, setEditLeaveYear] = useState(false);
  const [checked, setChecked] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState(false);
  const [dateSelectionView, setDateSelectionView] = useState("calendar");
  const [selectedDates, setSelectedDates] = useState([]);
  const { domain, token, userDetails, topbarCompanyId, userScreenAccess } =
    useSelector((state) => state.tokenReducer);
  // A request created here from Team Workspace Approve used to always post
  // status:"Approved" with the creator as approver_id, regardless of
  // whether they actually hold approver permission for Leaves — so anyone
  // with only editor access auto-approved their own creation in one step,
  // skipping the real approval workflow entirely. This screen's own
  // check_access only ever checked editor permission (see index.js), and
  // first/second-level approver permission wasn't checked anywhere in this
  // module before now. Either level counts as "can approve" — there's no
  // visible two-stage (level 1 then level 2) workflow in the UI today, so
  // they're treated as equivalent approval rights for this gate.
  const hasApproverAccess =
    checkFirstLevelApproverPermission(
      userScreenAccess?.module_details,
      "Approvals",
      "Leaves",
    ) ||
    checkSecondLevelApproverPermission(
      userScreenAccess?.module_details,
      "Approvals",
      "Leaves",
    );
  const { result: users, loading: usersLoading } = useFetch(
    `${domain}list/employee?user_id=${userDetails.id}&company_id=${topbarCompanyId}`,
  );
  const today = dayjs();
  const [leaveYear, setLeaveYear] = useState([]);
  const [leaveDetailsLoading, setLeaveDetailsLoading] = useState(false);
  const [updateDates, setUpdateDates] = useState(true);
  const [isSandwichApplied, setIsSandwichApplied] = useState(false);
  const [isSandwichViolation, setIsSandwichViolation] = useState(false);
  const [isWeekoffApplied, setIsWeekoffApplied] = useState(false);
  const [isHolidayApplied, setIsHolidayApplied] = useState(false);
  const [sandwichMessage, setSandwichMessage] = useState("");
  const skipValidationRef = useRef(false);
  const lastValidationKeyRef = useRef("");
  const contentLeft = useExpandedContentLeft(expanded);

  useEffect(() => {
    if (open) {
      reset();
      setDateSelectionView("calendar");
      setSelectedDates([]);
      setShowAutoCompleteAvathar(false);
      setcheckboxChecked(true);
      setMultiDaysCheckboxChecked(false);
      setFirstHalfChecked(false);
      setSecondHalfChecked(false);
      setLeaveTypeOptions([]);
      setEditLeaveYear(false);
      setChecked(false);
      setLeaveTypes(false);
      setUpdateDates(true);
      setIsSandwichApplied(false);
      setIsSandwichViolation(false);
      setIsWeekoffApplied(false);
      setIsHolidayApplied(false);
      setSandwichMessage("");
      skipValidationRef.current = false;
      lastValidationKeyRef.current = "";
    }
  }, [open, reset]);

  useEffect(() => {
    if (!expanded) return;
    if (typeof document === "undefined") return;

    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [expanded]);

  useEffect(() => {
    if (updateDates) {
      setValue("to_date", today);
      setValue("from_date", today);
      setUpdateDates(false);
    }
  }, [setValue, today, updateDates]);

  const selectLeaveType = (event, data) => {
    if (data) {
      setValue("leave_type", data?.label);
      setValue("leave_type_id", data?.leave_type_id ?? data?.id);
    } else {
      setValue("leave_type", "");
      setValue("leave_type_id", "");
      setValue("business_days", "");
      setIsSandwichApplied(false);
      setIsSandwichViolation(false);
      setIsWeekoffApplied(false);
      setIsHolidayApplied(false);
      setSandwichMessage("");
      lastValidationKeyRef.current = "";
    }
  };

  useEffect(() => {
    if (watch("from_date")) {
      setValue("end_date", watch("from_date"));
    }
  }, [setValue, watch]);

  const watchedFromDate = watch("from_date");
  const watchedToDate = watch("to_date");
  const watchedLeaveTypeId = watch("leave_type_id");
  const watchedUserId = watch("user_id");
  const isHalfDaySelected = firstHalfChecked || secondHalfChecked;
  // Dates already submitted (from an earlier partial batch) are done —
  // they neither need re-validating nor should block a retry of the rest.
  const pendingCalendarDates = selectedDates.filter(
    (entry) => entry.submissionStatus !== "submitted",
  );
  const calendarDatesInvalid =
    pendingCalendarDates.length === 0 ||
    pendingCalendarDates.some(
      (entry) =>
        entry.validationKey !==
          JSON.stringify([
            watchedUserId,
            watchedLeaveTypeId,
            entry.date,
            entry.dayType,
          ]) ||
        Boolean(entry.validationError) ||
        Boolean(entry.overlapError),
    );

  // The calendar's month picker should only offer months inside the
  // currently selected leave year, not an arbitrary rolling window that has
  // nothing to do with which year's balances/requests this panel is for.
  // filteredValue only matches an entry's own filteredValue once the user
  // has explicitly picked one via the edit control below (the initial value
  // set on load doesn't share that exact format) — fall back to the first
  // (default) leave year in that case.
  const selectedLeaveYear =
    leaveYear.find((year) => year.filteredValue === filteredValue) || leaveYear[0];
  const leaveYearStartDate = selectedLeaveYear?.start_date
    ? dayjs(parse(selectedLeaveYear.start_date, "dd-MM-yyyy", new Date())).format("YYYY-MM-DD")
    : null;
  const leaveYearEndDate = selectedLeaveYear?.end_date
    ? dayjs(parse(selectedLeaveYear.end_date, "dd-MM-yyyy", new Date())).format("YYYY-MM-DD")
    : null;
  useEffect(() => {
    setSelectedDates([]);
  }, [watchedUserId]);

  const changeDateSelectionView = (event, nextView) => {
    if (!nextView) return;
    if (nextView === "default") {
      setSelectedDates([]);
    }
    if (nextView === "calendar") {
      clearErrors(["from_date", "to_date"]);
    }
    setDateSelectionView(nextView);
  };
  const shouldShowEndDate =
    multiDaysCheckboxChecked ||
    (watchedFromDate &&
      watchedToDate &&
      dayjs(watchedFromDate).format("YYYY-MM-DD") !==
        dayjs(watchedToDate).format("YYYY-MM-DD"));

  const formatDateForApi = (value) => {
    if (!value || !dayjs(value).isValid()) {
      return "";
    }
    return dayjs(value).format("YYYY-MM-DD");
  };

  const validateLeaveRequest = useCallback(
    async ({
      fromDate,
      toDate,
      leaveTypeId,
      userId,
      isHalfDay,
      preserveMultipleDays = false,
    }) => {
      const validationKey = JSON.stringify({
        user: userId,
        leave_type_id: leaveTypeId,
        from_date: fromDate,
        to_date: toDate,
        is_half_day: isHalfDay,
      });

      if (lastValidationKeyRef.current === validationKey) {
        return;
      }

      lastValidationKeyRef.current = validationKey;

      try {
        const response = await fetch(`${domain}validate-leave-request`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
          body: JSON.stringify({
            user: userId,
            leave_type_id: leaveTypeId,
            from_date: fromDate,
            to_date: toDate,
            is_half_day: isHalfDay,
          }),
        });
        const res = await response.json();
        if (response.ok) {
          const validatedFromDate = dayjs(res?.from_date);
          const validatedToDate = isHalfDay
            ? validatedFromDate
            : dayjs(res?.to_date);
          const isMultiDayRange =
            !isHalfDay && res?.from_date && res?.to_date
              ? res.from_date !== res.to_date
              : false;
          const shouldStayMultipleDays =
            !isHalfDay && (preserveMultipleDays || isMultiDayRange);
          skipValidationRef.current = true;
          setValue("from_date", validatedFromDate);
          setValue("to_date", validatedToDate);
          setValue("business_days", res?.business_days ?? "");
          setValue("sandwich_applied", res?.sandwich_applied ?? false);
          setMultiDaysCheckboxChecked(shouldStayMultipleDays);
          setcheckboxChecked(isHalfDay ? false : !shouldStayMultipleDays);
          setIsSandwichApplied(Boolean(res?.sandwich_applied));
          setIsSandwichViolation(Boolean(res?.sandwich_violation));
          setIsWeekoffApplied(Boolean(res?.is_weekoff_applied));
          setIsHolidayApplied(Boolean(res?.is_holiday_applied));
          setSandwichMessage(
            res?.sandwich_applied || res?.sandwich_violation
              ? res?.message || ""
              : "",
          );
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    },
    [domain, setValue, token],
  );

  useEffect(() => {
    if (dateSelectionView === "calendar") return;
    if (skipValidationRef.current) {
      skipValidationRef.current = false;
      return;
    }

    const fromDate = formatDateForApi(watchedFromDate);
    const toDate = formatDateForApi(watchedToDate);
    const hasInvalidRange =
      watchedFromDate &&
      watchedToDate &&
      dayjs(watchedToDate).isBefore(dayjs(watchedFromDate), "day");

    if (
      !fromDate ||
      !toDate ||
      !watchedLeaveTypeId ||
      !watchedUserId ||
      hasInvalidRange
    ) {
      setIsSandwichApplied(false);
      setIsSandwichViolation(false);
      setIsWeekoffApplied(false);
      setIsHolidayApplied(false);
      setSandwichMessage("");
      setValue("business_days", "");
      lastValidationKeyRef.current = "";
      return;
    }

    validateLeaveRequest({
      fromDate,
      toDate,
      leaveTypeId: watchedLeaveTypeId,
      userId: watchedUserId,
      isHalfDay: isHalfDaySelected,
      preserveMultipleDays: multiDaysCheckboxChecked,
    });
  }, [
    dateSelectionView,
    isHalfDaySelected,
    multiDaysCheckboxChecked,
    setValue,
    validateLeaveRequest,
    watchedFromDate,
    watchedLeaveTypeId,
    watchedToDate,
    watchedUserId,
  ]);

  useEffect(() => {
    const fetchLeaveTypeOptions = async () => {
      setLeaveDetailsLoading(true);
      try {
        const response = await fetch(
          `${domain}leavetypefilter/?user_id=${watch("user_id")}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          },
        );
        const res = await response.json();
        if (response.ok) {
          Array.isArray(setLeaveTypeOptions(res));
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error("REQUEST_FAILED");
        }
      } catch (error) {
        console.error("[Apply] operation failed:", error);
        showToast(
          "error",
          "Couldn't load leave details. Please refresh the page.",
        );
      } finally {
        setLeaveDetailsLoading(false);
      }
    };
    if (watch("user_id") && leaveTypes) {
      fetchLeaveTypeOptions();
      setLeaveTypes(false);
    }
  }, [domain, leaveTypes, token, userDetails.id, watch]);

  useEffect(() => {
    const fetchLeaveDate = async () => {
      try {
        const response = await fetch(`${domain}leaves-years/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });
        const res = await response.json();
        if (response.ok) {
          const results = res.results;
          const leaveDate = results.map((value) => ({
            label: `${value.name} (${value.start_date} - ${value.end_date})`,
            start_date: value.start_date,
            end_date: value.end_date,
            filteredValue: `${value.name} (${value.start_date} - ${value.end_date})`,
          }));
          setLeaveYear(leaveDate);
          setFilteredValue(
            `${results[0]?.start_date} - ${results[0]?.end_date}`,
          );
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error("REQUEST_FAILED");
        }
      } catch (error) {
        console.error("[Apply] operation failed:", error);
        showToast(
          "error",
          "Couldn't load leave details. Please refresh the page.",
        );
      }
    };
    fetchLeaveDate();
  }, [domain, setFilteredValue, token]);

  const handleReason = (event) => {
    if (event.target.value.length <= 1024) {
      setValue("reason_for_leave", event.target.value);
    }
  };

  const updateLeavePeriod = (event, value) => {
    // Calendar dates were picked against the previous leave year's balances
    // and month range — carrying them over into a different leave year
    // would silently submit them against the wrong period, so start over.
    setSelectedDates([]);
    if (value && value.filteredValue) {
      setFilteredValue(value.filteredValue);

      const startDate = parse(value.start_date, "dd-MM-yyyy", new Date());
      const endDate = parse(value.end_date, "dd-MM-yyyy", new Date());
      const currentYear = new Date().getFullYear();

      if (
        startDate.getFullYear() === currentYear ||
        endDate.getFullYear() === currentYear
      ) {
        const today = dayjs();
        setValue("from_date", today);
        setValue("to_date", today);
      } else {
        setValue("from_date", dayjs(startDate));
        setValue("to_date", dayjs(endDate));
      }
    } else {
      setFilteredValue("");
    }
  };

  const handleFirstHalfCheckboxChanged = (event) => {
    const checked = event.target.checked;
    lastValidationKeyRef.current = "";

    if (checked) {
      setSecondHalfChecked(false);
      setcheckboxChecked(false);
      setFirstHalfChecked(checked);
    } else {
      setFirstHalfChecked(!checked);
    }
  };

  const handleSecondHalfCheckboxChanged = (event) => {
    const checked = event.target.checked;
    lastValidationKeyRef.current = "";
    if (checked) {
      setFirstHalfChecked(false);
      setcheckboxChecked(false);
      setSecondHalfChecked(checked);
    } else {
      setSecondHalfChecked(!checked);
    }
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    lastValidationKeyRef.current = "";
    setcheckboxChecked(checked);
    setMultiDaysCheckboxChecked(false);
    const currentFromDate = watch("from_date") || dayjs();
    if (checked) {
      setValue("from_date", currentFromDate);
      setValue("to_date", currentFromDate);
      setSecondHalfChecked(false);
      setFirstHalfChecked(false);
      setChecked(false);
    } else {
      setValue("from_date", currentFromDate);
      setValue("to_date", currentFromDate);
      setSecondHalfChecked(false);
      setFirstHalfChecked(false);
      setChecked(false);
    }
  };

  const handleMultiDaysCheckboxChange = (event) => {
    const checked = event.target.checked;
    lastValidationKeyRef.current = "";
    setMultiDaysCheckboxChecked(checked);
    setcheckboxChecked(false);
    const currentFromDate = watch("from_date") || dayjs();
    if (checked) {
      setValue("from_date", currentFromDate);
      setValue("to_date", null);
      setSecondHalfChecked(false);
      setFirstHalfChecked(false);
      setChecked(false);
    } else {
      setValue("from_date", currentFromDate);
      setValue("to_date", currentFromDate);
      setSecondHalfChecked(false);
      setFirstHalfChecked(false);
      setChecked(false);
    }
  };

  const handleCheckboxChanged = (event) => {
    const isChecked = event.target.checked;
    lastValidationKeyRef.current = "";
    setcheckboxChecked(false);
    setMultiDaysCheckboxChecked(false);
    setChecked(isChecked);
    if (isChecked) {
      setcheckboxChecked(false);
      setFirstHalfChecked(true);
    } else {
      setcheckboxChecked(false);
      setFirstHalfChecked(false);
    }
  };

  const markCalendarDateStatus = (dateStr, submissionStatus) => {
    setSelectedDates((previous) =>
      previous.map((entry) =>
        entry.date === dateStr ? { ...entry, submissionStatus } : entry,
      ),
    );
  };

  const submitCalendarDates = async (data) => {
    if (calendarDatesInvalid) {
      showToast(
        "error",
        "Select dates and resolve their validation messages before approving.",
      );
      return;
    }
    setValue("button_loader", true);
    let submittedCount = 0;
    try {
      // A retry after a partial failure re-runs this against the same
      // selectedDates list — dates already marked submitted are done and
      // must not be posted a second time.
      const pendingDates = selectedDates.filter(
        (entry) => entry.submissionStatus !== "submitted",
      );
      const requests = [];
      for (const selectedDate of pendingDates) {
        const isHalfDay = selectedDate.dayType !== "full";
        // Calendar selection validates each date and blocks approval until
        // that result matches the current employee, leave type and duration.
        requests.push({
          user: data.user_id,
          leave_type: data.leave_type,
          leave_type_id: data.leave_type_id,
          from_date: selectedDate.validatedFromDate || selectedDate.date,
          to_date: selectedDate.validatedToDate || selectedDate.date,
          business_days: selectedDate.businessDays,
          sandwich_applied: Boolean(selectedDate.sandwichApplied),
          comments: selectedDate.sandwichApplied
            ? selectedDate.validationMessage || null
            : null,
          is_weekoff_applied: Boolean(selectedDate.isWeekoffApplied),
          is_holiday_applied: Boolean(selectedDate.isHolidayApplied),
          is_half_day: isHalfDay,
          half_day_period:
            selectedDate.dayType === "half_am"
              ? "1st"
              : selectedDate.dayType === "half_pm"
                ? "2nd"
                : null,
          description: data.reason_for_leave,
          status: hasApproverAccess ? "Approved" : "Pending",
          approver_id: hasApproverAccess ? userDetails.id : undefined,
          applied_date: new Date().toISOString().split("T")[0],
          createdby: userDetails.first_name,
          createdat: new Date().toISOString(),
          modifiedby: userDetails.first_name,
          modifiedat: new Date().toISOString(),
        });
      }
      const orderedRequests = [...requests].sort((first, second) =>
        first.from_date.localeCompare(second.from_date),
      );
      if (
        orderedRequests.some(
          (request, index) =>
            index > 0 &&
            request.from_date <= orderedRequests[index - 1].to_date,
        )
      ) {
        throw new Error(
          "Leave rules expand these dates into overlapping ranges. Use the Default view to submit them as one date range.",
        );
      }
      for (const [index, request] of requests.entries()) {
        const submittedDate = pendingDates[index].date;
        markCalendarDateStatus(submittedDate, "submitting");
        const response = await fetch(`${domain}create/leave-request`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
          body: JSON.stringify(request),
        });
        const result = await response.json();
        if (response.status === 409) sessionHandling();
        if (!response.ok) {
          markCalendarDateStatus(submittedDate, "failed");
          throw new Error(
            result.error ||
              result.errors?.[0]?.message ||
              result.message ||
              "Couldn't submit your leave request.",
          );
        }
        submittedCount += 1;
        // Kept in selectedDates (marked submitted) instead of removed, so
        // the calendar keeps showing it as selected/approved rather than it
        // disappearing mid-batch while the remaining dates are still posting.
        markCalendarDateStatus(submittedDate, "submitted");
      }
      showToast("success", leaveSuccess.leaveRequest);
      onClose();
    } catch (error) {
      showToast(
        "error",
        `${submittedCount ? `${submittedCount} date(s) approved. Remaining dates are still selected. ` : ""}${error.message}`,
      );
    } finally {
      if (submittedCount) setReCallApi(true);
      setValue("button_loader", false);
    }
  };

  const onSubmit = async (data) => {
    if (dateSelectionView === "calendar") {
      await submitCalendarDates(data);
      return;
    }
    // setButtonLoader(true);
    setValue("button_loader", true);
    try {
      const halfDay = firstHalfChecked || secondHalfChecked;
      const whichHalf = firstHalfChecked
        ? "1st"
        : secondHalfChecked
          ? "2nd"
          : null;
      const currentLeaveType = leaveTypeOptions?.filter((leave) => {
        return leave.leave_type === data.leave_type;
      });
      const response = await fetch(`${domain}create/leave-request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
        body: JSON.stringify({
          ...data,
          to_date: data?.to_date.format("YYYY-MM-DD"),
          from_date: data?.from_date.format("YYYY-MM-DD"),
          business_days: data?.business_days,
          sandwich_applied: data?.sandwich_applied,
          comments: data?.sandwich_applied ? sandwichMessage || null : null,
          is_weekoff_applied: isWeekoffApplied,
          is_holiday_applied: isHolidayApplied,
          description: data?.reason_for_leave,
          is_half_day: halfDay,
          half_day_period: whichHalf,
          user: data.user_id,
          status: hasApproverAccess ? "Approved" : "Pending",
          approver_id: hasApproverAccess ? userDetails.id : undefined,
          applied_date: new Date().toISOString().split("T")[0],
          createdby: userDetails.first_name,
          createdat: new Date().toISOString(),
          modifiedby: userDetails.first_name,
          modifiedat: new Date().toISOString(),
          leave_type_id: currentLeaveType[0].id,
        }),
      });
      const res = await response.json();
      if (response.ok) {
        showToast("success", leaveSuccess.leaveRequest);
        // setButtonLoader(false);
        setValue("leave_type", "");
        setValue("leave_type_id", "");
        reset();
        setcheckboxChecked(false);
        setChecked(false);
        // setLeaveTypeDetails("");
        setFirstHalfChecked(false);
        setSecondHalfChecked(false);
        setIsSandwichApplied(false);
        setIsSandwichViolation(false);
        setIsWeekoffApplied(false);
        setIsHolidayApplied(false);
        setSandwichMessage("");
        lastValidationKeyRef.current = "";
        setReCallApi(true);
        onClose();
        setValue("button_loader", false);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        setValue("button_loader", false);
        throw new Error(
          res?.error ||
            res?.errors?.[0]?.message ||
            res?.message ||
            "Couldn't submit your leave request. Please try again.",
        );
      }
    } catch (error) {
      console.error("[Apply] operation failed:", error);
      setValue("button_loader", false);
      showToast("error", error.message);
      //   setButtonLoader(false);
    }
  };

  const LeaveTypeCard = ({ title, credited, used }) => {
    const remaining = credited - used;

    const usedPercent = credited ? (used / credited) * 100 : 0;

    return (
      <Mui.Card
        sx={{
          borderRadius: designRadii.card,
          backgroundColor: designColors.slateBg,
          border: `1px solid ${designColors.slate200}`,
          boxShadow: "0px 2px 6px rgba(0,0,0,0.04)",
        }}
      >
        {/* Header */}
        <Mui.Box
          sx={{
            px: 2,
            py: 1.5,
            borderBottom: `1px solid ${designColors.slate200}`,
            ...leaveFieldLabelSx,
          }}
        >
          {title}
        </Mui.Box>

        <Mui.CardContent sx={{ pt: 2 }}>
          {/* Credited Row */}
          <Mui.Box display="flex" justifyContent="space-between" mb={1}>
            <Typography sx={{ ...leaveInfoStyle.sx, mb: 0 }}>
              <Mui.Box component="b" sx={{ color: designColors.slate800 }}>
                Available:
              </Mui.Box>{" "}
              {remaining} Days
            </Typography>
          </Mui.Box>

          {/* Multi-color progress */}
          <Mui.Box
            sx={{
              height: 8,
              borderRadius: 5,
              overflow: "hidden",
              backgroundColor: designColors.slate200,
              display: "flex",
              mb: 2,
            }}
          >
            {/* Used part */}
            <Mui.Box
              sx={{
                width: `${usedPercent}%`,
                backgroundColor: "#f2994a", // orange used
              }}
            />

            {/* Remaining part */}
            <Mui.Box
              sx={{
                flex: 1,
                backgroundColor: designColors.teal,
              }}
            />
          </Mui.Box>

          {/* Used Row */}
          <Mui.Box display="flex" justifyContent="space-between">
            <Typography sx={{ ...leaveInfoStyle.sx, mb: 0 }}>
              <Mui.Box component="b" sx={{ color: designColors.slate800 }}>
                Used:
              </Mui.Box>{" "}
              {used} / {credited} Days
            </Typography>
          </Mui.Box>
        </Mui.CardContent>
      </Mui.Card>
    );
  };

  const updateUserName = (event, data) => {
    if (data) {
      setValue("user_name", data?.label);
      setValue("user_id", data?.user_id);
      setValue("selectedUser", data);
      setShowAutoCompleteAvathar(false);
      setLeaveTypes(true);
    } else {
      setValue("user_name", null);
      setValue("user_id", "");
      setValue("selectedUser", null);
      setShowAutoCompleteAvathar(true);
    }
  };

  const panelContent = (
    <Box
      sx={{
        ...parentBoxStyle,
        height: "100%",
        borderRadius: expanded ? designRadii.card : 0,
        overflow: "hidden",
        backgroundColor: designColors.white,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: 0,
          backgroundColor: designColors.white,
        }}
      >
        <Box sx={{ p: 3, pb: 0 }}>
          <Mui.Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            sx={{
              pb: 2.25,
              borderBottom: `1px solid ${designColors.slate200}`,
            }}
          >
            <Box>
              <Typography sx={designType.panelTitle}>
                New Leave Request
              </Typography>
              <Typography sx={{ ...designType.pageSubtitle, mt: 0.5 }}>
                Create a leave request for the selected date.
              </Typography>
            </Box>
            <Mui.Stack direction="row" spacing={1} alignItems="center">
              {onToggleExpand ? (
                expanded ? (
                  <PanelHeaderIconButton
                    expanded
                    title="Collapse"
                    onClick={onToggleExpand}
                  >
                    <CloseFullscreen />
                  </PanelHeaderIconButton>
                ) : (
                  <Mui.Tooltip arrow slotProps={tooltipStyleProps} title="Open full view">
                    <IconButton
                      onClick={onToggleExpand}
                      size="small"
                      sx={{
                        ...designShell.panelSoftIconButton,
                        color: designColors.slate500,
                      }}
                    >
                      <OpenFullViewIcon fontSize="small" />
                    </IconButton>
                  </Mui.Tooltip>
                )
              ) : null}
              {expanded ? (
                <PanelHeaderIconButton
                  expanded
                  title="Close"
                  onClick={onClose}
                >
                  <Close />
                </PanelHeaderIconButton>
              ) : (
                <IconButton
                  onClick={onClose}
                  size="small"
                  sx={{
                    ...designShell.panelSoftIconButton,
                    color: designColors.slate500,
                  }}
                >
                  <Close fontSize="small" />
                </IconButton>
              )}
            </Mui.Stack>
          </Mui.Stack>
        </Box>
      </Paper>
      <Mui.Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
      >
        <Box
          component="fieldset"
          disabled={Boolean(watch("button_loader"))}
          sx={{
            flex: 1,
            minHeight: 0,
            minWidth: 0,
            border: 0,
            m: 0,
            overflowY: "auto",
            px: 3,
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>

            <Box>
              <GlobalFieldLabel helperText="Select the employee for whom the leave request is being submitted.">
                Employee name
              </GlobalFieldLabel>
              {usersLoading ? (
                <Mui.Box
                  role="status"
                  aria-label="Loading employees"
                  aria-busy="true"
                >
                  <Mui.Skeleton
                    animation="wave"
                    variant="rounded"
                    height={44}
                  />
                </Mui.Box>
              ) : (
                <CustomAutoCompleteWithLogo
                  dataList={users?.map((obj) => ({
                    ...obj,
                    label: obj.user_name,
                    image: obj?.image_url,
                  }))}
                  selectedValue={watch("selectedUser")}
                  rules={{
                    ...register("user_name", {
                      required: "User name is required",
                    }),
                  }}
                  updateDataFunction={updateUserName}
                  placeHolder="Select the name"
                  errorMessage={
                    errors?.user_name?.message ? errors?.user_name?.message : ""
                  }
                  textBoxError={errors.user_name ? true : false}
                  showAvathar={showAutoCompleteAvathar}
                  setShowAutoCompleteAvathar={setShowAutoCompleteAvathar}
                />
              )}
            </Box>
            <SelectedEmployeeHeader selectedUser={watch("selectedUser")} />
            {watch("user_name") ? (
              <>
                <Box>
                  <Typography sx={leaveSectionTitleSx}>
                    Leave Balances
                  </Typography>
                  <Typography sx={{ ...leaveInfoStyle.sx, mb: 0 }}>
                    Choose the leave year for which you want to apply for leave.
                  </Typography>
                </Box>
                <Box>
                  <Mui.Stack direction="row" alignItems="center" spacing={0.75}>
                    <Typography sx={leaveFieldLabelSx}>Leave Year</Typography>
                    {!editLeaveYear ? (
                      <Typography sx={{ ...leaveInfoStyle.sx, mb: 0 }}>
                        {filteredValue}
                      </Typography>
                    ) : null}
                    {editLeaveYear ? null : (
                      <Edit
                        sx={{
                          fontSize: 16,
                          color: designColors.slate500,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setEditLeaveYear(true);
                        }}
                      />
                    )}
                  </Mui.Stack>
                  {editLeaveYear ? (
                    <Typography
                      {...leaveInfoStyle}
                      sx={{
                        ...leaveInfoStyle.sx,
                        mb: 0.5,
                        mt: 0.5,
                      }}
                    >
                      Choose the leave year
                    </Typography>
                  ) : null}
                  {editLeaveYear ? (
                    <CustomAutoComplete
                      dataList={leaveYear}
                      selectedValue={filteredValue}
                      updateDataFunction={updateLeavePeriod}
                      placeHolder="Select leave period"
                      // label={filteredLabel ? filteredLabel : "Leave Period"}
                    />
                  ) : null}
                </Box>
                <Mui.Grid container spacing={2} aria-busy={leaveDetailsLoading}>
                  {leaveDetailsLoading ? (
                    <Mui.Grid
                      item
                      xs={12}
                      role="status"
                      aria-label="Loading leave balances"
                    >
                      <Mui.Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            xs: "1fr",
                            md: "repeat(3, 1fr)",
                          },
                          gap: 2,
                        }}
                      >
                        {[0, 1, 2].map((item) => (
                          <Mui.Skeleton
                            key={item}
                            animation="wave"
                            variant="rounded"
                            height={120}
                          />
                        ))}
                      </Mui.Box>
                    </Mui.Grid>
                  ) : (
                    leaveTypeOptions?.map((leave, index) => {
                      const progressColor =
                        leave.leave_type === "Casual Leave"
                          ? "success"
                          : leave.leave_type === "Sick leave"
                            ? "warning"
                            : "primary";

                      return (
                        <Mui.Grid
                          item
                          xs={12}
                          md={Math.max(
                            4,
                            Math.floor(12 / (leaveTypeOptions?.length || 1)),
                          )}
                          key={index}
                        >
                          <LeaveTypeCard
                            title={leave.leave_type}
                            credited={leave.credited_leave}
                            used={leave.used_leave}
                            progressColor={progressColor}
                          />
                        </Mui.Grid>
                      );
                    })
                  )}
                </Mui.Grid>
                <Box>
                  <Typography sx={leaveSectionTitleSx}>
                    Apply for Leave
                  </Typography>
                  <Typography sx={{ ...leaveInfoStyle.sx, mb: 0 }}>
                    Fill in the leave type, dates and reason below to submit the request.
                  </Typography>
                </Box>
                <Box>
                  <GlobalFieldLabel helperText="Choose the leave type you want to apply for.">
                    Leave Type
                  </GlobalFieldLabel>
                  {leaveDetailsLoading ? (
                    <Mui.Box
                      role="status"
                      aria-label="Loading leave types"
                      aria-busy="true"
                    >
                      <Mui.Skeleton
                        animation="wave"
                        variant="rounded"
                        height={44}
                      />
                    </Mui.Box>
                  ) : (
                    <CustomAutoComplete
                      dataList={leaveTypeOptions?.map((obj) => ({
                        ...obj,
                        label: obj?.leave_type,
                      }))}
                      rules={{
                        ...register("leave_type", {
                          required: "Leave Type is required",
                        }),
                      }}
                      selectedValue={watch("leave_type")}
                      updateDataFunction={selectLeaveType}
                      placeHolder="Select leave type"
                      errorMessage={
                        errors?.leave_type?.message
                          ? errors?.leave_type?.message
                          : ""
                      }
                      textBoxError={errors?.leave_type ? true : false}
                    />
                  )}
                </Box>
                <Mui.ToggleButtonGroup
                  exclusive
                  value={dateSelectionView}
                  onChange={changeDateSelectionView}
                  size="small"
                  aria-label="Date selection view"
                  disabled={Boolean(watch("button_loader"))}
                  sx={{
                    alignSelf: "flex-start",
                    "& .MuiToggleButton-root": {
                      textTransform: "none",
                      px: 2,
                      gap: 1,
                    },
                  }}
                >
                  <Mui.ToggleButton value="calendar">
                    <CalendarMonthOutlined fontSize="small" />
                    Calendar
                  </Mui.ToggleButton>
                  <Mui.ToggleButton value="default">
                    <DateRangeOutlined fontSize="small" />
                    Default
                  </Mui.ToggleButton>
                </Mui.ToggleButtonGroup>
                {dateSelectionView === "calendar" ? (
                  <LeaveDateCalendar
                    domain={domain}
                    token={token}
                    topbarCompanyId={topbarCompanyId}
                    userId={watchedUserId}
                    departmentId={watch("selectedUser")?.department_id}
                    department={watch("selectedUser")?.department}
                    departmentName={watch("selectedUser")?.department_name}
                    requestingUserId={userDetails.id}
                    leaveTypeId={watchedLeaveTypeId}
                    selectedDates={selectedDates}
                    onChange={setSelectedDates}
                    leaveYearStartDate={leaveYearStartDate}
                    leaveYearEndDate={leaveYearEndDate}
                  />
                ) : null}
                <Box
                  sx={{
                    display:
                      dateSelectionView === "default" ? "contents" : "none",
                  }}
                >
                  <Mui.Grid container>
                    <Mui.Grid item xs={4}>
                      <Mui.FormControlLabel
                        control={<Mui.Radio />}
                        label="Single Day"
                        checked={checkboxChecked}
                        onChange={handleCheckboxChange}
                        sx={leaveRadioLabelSx}
                      />
                    </Mui.Grid>
                    <Mui.Grid item xs={4}>
                      <Mui.FormControlLabel
                        control={<Mui.Radio />}
                        label="Multiple Days"
                        checked={multiDaysCheckboxChecked}
                        onChange={handleMultiDaysCheckboxChange}
                        sx={leaveRadioLabelSx}
                      />
                    </Mui.Grid>
                    <Mui.Grid item xs={4}>
                      <Mui.FormControlLabel
                        control={
                          <Mui.Radio
                            checked={checked}
                            onChange={handleCheckboxChanged}
                          />
                        }
                        label="Half Day"
                        sx={leaveRadioLabelSx}
                      />
                    </Mui.Grid>
                  </Mui.Grid>
                  {checked && (
                    <Mui.Grid container>
                      <Mui.Grid item xs={6}>
                        <Mui.FormControlLabel
                          control={
                            <Mui.Radio
                              checked={firstHalfChecked}
                              onChange={handleFirstHalfCheckboxChanged}
                            />
                          }
                          label="1st-half"
                          sx={leaveRadioLabelSx}
                        />
                      </Mui.Grid>
                      <Mui.Grid item xs={6}>
                        <Mui.FormControlLabel
                          control={
                            <Mui.Radio
                              checked={secondHalfChecked}
                              onChange={handleSecondHalfCheckboxChanged}
                            />
                          }
                          label="2nd-half"
                          sx={leaveRadioLabelSx}
                        />
                      </Mui.Grid>
                    </Mui.Grid>
                  )}
                  <Box>
                    <GlobalFieldLabel
                      helperText={
                        shouldShowEndDate
                          ? "Select the start date"
                          : "Select the date for which you want to apply for leave."
                      }
                    >
                      {shouldShowEndDate ? "Start Date" : "Date"}
                    </GlobalFieldLabel>
                    <CustomizedDatePicker
                      name="from_date"
                      control={control}
                      required={dateSelectionView === "default"}
                      rules={
                        dateSelectionView === "calendar"
                          ? { validate: () => true }
                          : {}
                      }
                      requiredMessage="Start date is required"
                      placeholder="Select start date"
                      onChange={(newValue) => {
                        const currentToDate =
                          getValues("to_date") || watchedToDate;
                        setValue("from_date", newValue);
                        if (!multiDaysCheckboxChecked) {
                          setValue("to_date", newValue);
                          return;
                        }

                        if (
                          currentToDate &&
                          dayjs(currentToDate).isBefore(dayjs(newValue), "day")
                        ) {
                          setValue("to_date", newValue);
                        }
                      }}
                    />
                  </Box>
                  {shouldShowEndDate ? (
                    <Box>
                      <GlobalFieldLabel helperText="Select the end date">
                        End Date
                      </GlobalFieldLabel>
                      <CustomizedDatePicker
                        name="to_date"
                        control={control}
                        required={dateSelectionView === "default"}
                        rules={
                          dateSelectionView === "calendar"
                            ? { validate: () => true }
                            : {}
                        }
                        requiredMessage="End date is required"
                        placeholder="Select end date"
                        startDate={watch("from_date")}
                      />
                    </Box>
                  ) : null}
                  {isSandwichApplied || isSandwichViolation ? (
                    <Box
                      sx={{
                        padding: 1.5,
                        borderRadius: 1,
                        backgroundColor: isSandwichViolation
                          ? "#FDECEA"
                          : "#FFF4CC",
                        border: `1px solid ${
                          isSandwichViolation ? "#F5C6CB" : "#F2D680"
                        }`,
                      }}
                    >
                      <Mui.Grid container direction="column" spacing={1}>
                        {watch("business_days") ? (
                          <Mui.Grid item>
                            <Typography
                              sx={{
                                fontWeight: 700,
                                color: isSandwichViolation
                                  ? "#B71C1C"
                                  : "#A15C00",
                              }}
                            >
                              Business Days
                            </Typography>
                            <Typography
                              sx={{
                                ...leaveInfoStyle.sx,
                                color: isSandwichViolation
                                  ? "#B71C1C"
                                  : "#A15C00",
                                mb: 0,
                              }}
                            >
                              {watch("business_days")}
                            </Typography>
                          </Mui.Grid>
                        ) : null}
                        {isSandwichApplied && sandwichMessage ? (
                          <Mui.Grid item>
                            <Typography
                              sx={{ fontWeight: 700, color: "#A15C00" }}
                            >
                              Info
                            </Typography>
                            <Typography
                              sx={{
                                ...leaveInfoStyle.sx,
                                color: "#A15C00",
                                mb: 0,
                              }}
                            >
                              {sandwichMessage}
                            </Typography>
                          </Mui.Grid>
                        ) : null}
                        {isSandwichViolation && sandwichMessage ? (
                          <Mui.Grid item>
                            <Typography
                              sx={{ fontWeight: 700, color: "#B71C1C" }}
                            >
                              Info
                            </Typography>
                            <Typography
                              sx={{
                                ...leaveInfoStyle.sx,
                                color: "#B71C1C",
                                mb: 0,
                              }}
                            >
                              {sandwichMessage}
                            </Typography>
                          </Mui.Grid>
                        ) : null}
                      </Mui.Grid>
                    </Box>
                  ) : null}
                </Box>
                <Box>
                  <GlobalFieldLabel helperText="Enter the reason for this leave request">
                    Reason
                  </GlobalFieldLabel>
                  <CustomTextBox
                    type="multiline"
                    rules={{
                      ...register("reason_for_leave", {
                        required: "Reason is required",
                      }),
                    }}
                    selectedValue={watch("reason_for_leave")}
                    updateDataFunction={handleReason}
                    placeHolder="Enter the reason for leave"
                    errorMessage={
                      errors?.reason_for_leave?.message
                        ? errors?.reason_for_leave?.message
                        : ""
                    }
                    textBoxError={errors?.reason_for_leave ? true : false}
                  />
                </Box>
              </>
            ) : null}
          </Box>
        </Box>
        {watch("user_name") ? (
          <Mui.Box
            sx={{
              px: 3,
              py: 1.25,
              borderTop: `1px solid ${designColors.slate200}`,
              backgroundColor: designColors.white,
            }}
          >
            <Mui.Stack direction="row" spacing={1.25} justifyContent="flex-end">
              <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
              <PrimaryButton
                type="submit"
                loading={Boolean(watch("button_loader"))}
                disabled={
                  Boolean(watch("button_loader")) ||
                  (dateSelectionView === "calendar"
                    ? calendarDatesInvalid
                    : isSandwichViolation)
                }
                sx={{ minWidth: FORM_ACTION_BUTTON_WIDTH }}
              >
                {hasApproverAccess ? "Approve" : "Apply"}
              </PrimaryButton>
            </Mui.Stack>
          </Mui.Box>
        ) : null}
      </Mui.Box>
    </Box>
  );

  if (expanded) {
    return createPortal(
      <Box
        sx={{
          position: "fixed",
          top: APP_BAR_OFFSET,
          left: `${contentLeft}px`,
          right: 0,
          bottom: 0,
          zIndex: 10,
          overflow: "hidden",
          backgroundColor: designColors.pageBg,
          p: 2,
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ height: "100%", minHeight: "100%", width: "100%" }}>
          {panelContent}
        </Box>
      </Box>,
      document.body,
    );
  }

  return (
    <Mui.Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={panelDrawerSx()}
    >
      <Box sx={{ width: PANEL_DRAWER_WIDTH, maxWidth: "100%", height: "100%" }}>
        {panelContent}
      </Box>
    </Mui.Drawer>
  );
};
